module.exports = __webpack_public_path__ + "img/10.178416f4.png";